import { initDataList } from '../../../../../../core/types/coreTypes';
import { RectificationBySupplierData } from '../../../../../types/RectificationsBySupplierReportTypes';

export const initRectificationsBySupplierData: RectificationBySupplierData = {
  ...initDataList,
  minUsedInRectifications: 0,
  maxUsedInRectifications: 0,
};
